import { useEffect, useRef, useState } from "react";

interface FiltersState {
  services: Record<number, boolean>;
  needType: "at_need" | "pre_need" | "";
  priceRange?: [number, number];
  distanceRange?: [number, number];
  ratings?: number[];
  userLat?: number | null;
  userLong?: number | null;
  sortBy?: string;
}

export function useFilterLogic(initialFilters: FiltersState, onChange: any) {
  // STATES
  const [filters, setFilters] = useState(initialFilters);
  const shouldSkipNextChange = useRef(true);

  // HOOKS
  useEffect(() => {
    if (shouldSkipNextChange.current) {
      shouldSkipNextChange.current = false;
      return;
    }

    const handler = setTimeout(() => {
      onChange(filters);
    }, 1000);

    return () => clearTimeout(handler);
  }, [filters]);

  useEffect(() => {
    shouldSkipNextChange.current = true;
    setFilters(initialFilters);
  }, [initialFilters]);

  // RESET FILTER FUNCTION
  const resetFilters = () => {
    setFilters({
      services: {},
      needType: "",
      // priceRange: [0, 7000],
      // distanceRange: [0, 7000],
      ratings: [],
    });
  };

  return {
    filters,
    setFilters,
    resetFilters,
  };
}
